import { Component } from '@angular/core';

import { pedidoRevisao } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-revisao',
    templateUrl: './pedido-status-badge-revisao.component.html',
    styleUrls: ['./pedido-status-badge-revisao.component.less']
})
export class PedidoStatusBadgeRevisaoComponent {
    status = pedidoRevisao;
}
